'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = ColGroup;
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var PropTypes = _interopRequireWildcard(_propTypes);
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj['default'] = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}
function ColGroup(props, _ref) {
  var table = _ref.table;
  var _table$props = table.props,
    prefixCls = _table$props.prefixCls,
    expandIconAsCell = _table$props.expandIconAsCell;
  var fixed = props.fixed;
  var cols = [];
  if (expandIconAsCell && fixed !== 'right') {
    cols.push(_react2['default'].createElement('col', {
      className: prefixCls + '-expand-icon-col',
      key: 'rc-table-expand-icon-col'
    }));
  }
  var leafColumns = void 0;
  if (fixed === 'left') {
    leafColumns = table.columnManager.leftLeafColumns();
  } else if (fixed === 'right') {
    leafColumns = table.columnManager.rightLeafColumns();
  } else {
    leafColumns = table.columnManager.leafColumns();
  }
  cols = cols.concat(leafColumns.map(function (c) {
    return _react2['default'].createElement('col', {
      key: c.key || c.dataIndex,
      style: {
        width: c.width,
        minWidth: c.minWidth || c.width
      }
    }); //modified by njq.niu@hand-china.com
  }));

  return _react2['default'].createElement('colgroup', null, cols);
}
ColGroup.propTypes = {
  fixed: PropTypes.string
};
ColGroup.contextTypes = {
  table: PropTypes.any
};
module.exports = exports['default'];